import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "h-full w-full relative flex flex-col overflow-hidden" }
const _hoisted_3 = {
  id: "filterSection",
  class: "flex justify-between w-full h-10"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex w-full justify-end items-center mr-3" }
const _hoisted_6 = { class: "text-sm text-primary" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-sm mb-2" }
const _hoisted_9 = { class: "hidden md:flex gap-2 flex-row justify-start mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_input_search = _resolveComponent("input-search")!
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_icon_filter = _resolveComponent("icon-filter")!
  const _component_icon_container = _resolveComponent("icon-container")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_filter_item = _resolveComponent("filter-item")!
  const _component_drop_down = _resolveComponent("drop-down")!
  const _component_item_list = _resolveComponent("item-list")!
  const _component_normlist_modal = _resolveComponent("normlist-modal")!
  const _component_side_container = _resolveComponent("side-container")!
  const _component_main_container = _resolveComponent("main-container")!

  return (_openBlock(), _createBlock(_component_main_container, {
    id: 'norm_overview',
    name: 'norm_overview',
    title: _ctx.$t('norm_overview')
  }, {
    actionButton: _withCtx(() => [
      _createVNode(_component_custom_button, {
        class: "w-auto",
        id: 'customAccept',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNormlistModal = true))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("normlist")), 1)
        ]),
        _: 1
      })
    ]),
    append: _withCtx(() => [
      _createVNode(_component_side_container, {
        open: _ctx.openDetails,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeNormDetails()))
      }, null, 8, ["open"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_input_search, {
            class: "w-64 h-10 flex-shrink-0",
            id: 'id',
            name: 'textFilter',
            modelValue: _ctx.params.search,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.search) = $event)),
            placeholder: 'Nummern, Titel'
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (
                                _ctx.params.search ||
                                _ctx.params.policy_ids.length > 0 ||
                                _ctx.params.type_ids.length > 0
                            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "flex items-center cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.clearAllFilters()), ["stop"]))
                  }, [
                    _createVNode(_component_icon_close, {
                      color: 'primary',
                      class: "transform scale-90 mt-px"
                    }),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("clear_all_filter")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_drop_down, {
                id: 'filterDropdown',
                ref: "dropdownElement",
                dropdownStyle: { widthClasses: 'md:w-96 w-64' }
              }, {
                trigger: _withCtx(() => [
                  _createVNode(_component_icon_container, { id: 'navbar-search-icon' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_icon_filter, {
                        color: 
                                            _ctx.combinedFilter.length != 0
                                                ? 'primary'
                                                : 'grey-dark'
                                        
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  })
                ]),
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("filter")), 1),
                  _createVNode(_component_input_select, {
                    class: "-mb-2",
                    id: "selectInputPolicy",
                    name: "selectInputPolicy",
                    label: `${_ctx.$t('policy')} (${
                                        _ctx.params?.policy_ids?.length
                                    }/3)`,
                    isMultiSelect: true,
                    options: _ctx.filteredPolicies,
                    hasSearch: true,
                    searchValue: _ctx.policiesTextFilter,
                    selectItemConfiguration: {
                                        valueColumn: 'id',
                                        labelColumn: 'name',
                                    },
                    useValueColumnAsValue: true,
                    isInputDisabled: true,
                    modelValue: _ctx.params.policy_ids,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.policy_ids) = $event)),
                      _ctx.checkPolicyFilterLength
                    ]
                  }, null, 8, ["label", "options", "searchValue", "modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_input_select, {
                    id: "selectInputType",
                    name: "selectInputType",
                    label: `${_ctx.$t('type')} (${
                                        _ctx.params?.type_ids?.length
                                    }/3)`,
                    isMultiSelect: true,
                    options: _ctx.filteredTypes,
                    hasSearch: true,
                    searchValue: _ctx.typesTextFilter,
                    selectItemConfiguration: {
                                        valueColumn: 'id',
                                        labelColumn: 'short_name',
                                    },
                    isInputDisabled: true,
                    useValueColumnAsValue: true,
                    modelValue: _ctx.params.type_ids,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.type_ids) = $event)),
                      _ctx.checkTypeFilterLength
                    ]
                  }, null, 8, ["label", "options", "searchValue", "modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("div", {
                    class: "md:hidden grid grid-cols-2 gap-2 flex-row justify-start mr-2",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFilter, (filterItem) => {
                      return (_openBlock(), _createBlock(_component_filter_item, {
                        key: filterItem.index,
                        filter: filterItem,
                        onRemoveFilter: ($event: any) => (
                                            _ctx.removeFilterItem(filterItem)
                                        )
                      }, null, 8, ["filter", "onRemoveFilter"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFilter, (filterItem) => {
            return (_openBlock(), _createBlock(_component_filter_item, {
              key: filterItem.index,
              filter: filterItem,
              onRemoveFilter: ($event: any) => (_ctx.removeFilterItem(filterItem))
            }, null, 8, ["filter", "onRemoveFilter"]))
          }), 128))
        ]),
        _createVNode(_component_item_list, {
          onOpenDetails: _cache[6] || (_cache[6] = 
                    (normId) =>
                        _ctx.router.push({
                            name: 'CustomerNormAdministrationDetails',
                            params: { id: normId },
                        })
                )
        })
      ]),
      (_ctx.showNormlistModal)
        ? (_openBlock(), _createBlock(_component_normlist_modal, {
            key: 0,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showNormlistModal = false))
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}